import { render } from "./ItemList.vue?vue&type=template&id=715d8e7b&scoped=true"
import script from "./ItemList.vue?vue&type=script&lang=js"
export * from "./ItemList.vue?vue&type=script&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=715d8e7b&scoped=true&lang=css"
import "./ItemList.vue?vue&type=style&index=1&id=715d8e7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-715d8e7b"]])

export default __exports__